import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo } from "../brand/Logo";
import { NAV_LINKS } from "./Nav";
import { scrollToId } from "../../lib/scroll";
import { useSite } from "../../lib/site";

const LEGAL = [["terminos", "Términos del servicio"], ["privacidad", "Aviso de privacidad"], ["quienes-somos", "Quiénes somos"]];
const SOCIALS = ["instagram", "facebook", "linkedin", "youtube", "tiktok"];

export const Footer = () => {
  const { content } = useSite();
  const f = content.footer;
  const c = content.contacto;
  const year = new Date().getFullYear();
  return (
    <footer className="relative overflow-hidden bg-ink pt-24 text-white sm:pt-32" data-testid="site-footer">
      <div className="container-x">
        <div className="space-y-1">
          {f.slogan.map((line, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 1, delay: i * 0.12, ease: [0.2, 0.8, 0.2, 1] }}
              className={`font-display text-[2.6rem] font-semibold uppercase leading-[0.92] tracking-[-0.045em] sm:text-7xl lg:text-[7.5rem] ${i === 2 ? "text-leaf" : ""}`}
              data-testid={`footer-slogan-${i}`}
            >
              {line}
            </motion.p>
          ))}
        </div>
        <div className="mt-20 grid gap-12 border-t border-white/10 pt-14 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo tone="light" className="h-11" testId="footer-logo" />
            <p className="mt-6 max-w-sm text-base leading-relaxed text-[#AEB7D3]">{f.description}</p>
          </div>
          <div className="lg:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.14em] text-leaf">Navegación</p>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map(([id, label]) => (
                <li key={id}>
                  <button onClick={() => scrollToId(id)} className="text-sm text-[#C9D0E4] transition-colors hover:text-white" data-testid={`footer-link-${id}`}>{label}</button>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.14em] text-leaf">Legal</p>
            <ul className="mt-5 space-y-3">
              {LEGAL.map(([slug, label]) => (
                <li key={slug}>
                  <Link to={`/legal/${slug}`} className="text-sm text-[#C9D0E4] transition-colors hover:text-white" data-testid={`footer-legal-${slug}`}>{label}</Link>
                </li>
              ))}
              <li>
                <Link to="/login" className="text-sm text-[#C9D0E4] transition-colors hover:text-white" data-testid="footer-ingresar">Ingresar</Link>
              </li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.14em] text-leaf">Contacto</p>
            <ul className="mt-5 space-y-3 text-sm text-[#C9D0E4]" data-testid="footer-contact">
              {c.email && <li>{c.email.includes("@") ? <a href={`mailto:${c.email}`} className="hover:text-white">{c.email}</a> : c.email}</li>}
              {c.whatsapp && <li>WhatsApp: <a href={`https://wa.me/${c.whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="hover:text-white" data-testid="footer-whatsapp">{c.whatsapp}</a></li>}
              {c.phone && <li>Tel: {c.phone}</li>}
              {c.address && <li>{c.address}</li>}
            </ul>
            <div className="mt-5 flex flex-wrap gap-2">
              {SOCIALS.filter((s) => c[s]).map((s) => (
                <a key={s} href={c[s]} target="_blank" rel="noopener noreferrer" className="rounded-full border border-white/20 px-3 py-1.5 font-mono text-xs uppercase tracking-[0.1em] text-white/85 transition-colors hover:border-leaf hover:text-leaf" data-testid={`footer-social-${s}`}>
                  {s}
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 py-8 text-xs text-[#AEB7D3] md:flex-row md:items-center md:justify-between">
          <p>© {year} HAPPY PEOPLE FACTORY. {content.legal.company_name}</p>
          <p className="max-w-2xl md:text-right" data-testid="footer-disclaimer">{f.disclaimer}</p>
        </div>
      </div>
    </footer>
  );
};
